import { render, staticRenderFns } from "./DigitalSignatureField.vue?vue&type=template&id=59a48a98&scoped=true"
import script from "./DigitalSignatureField.vue?vue&type=script&lang=js"
export * from "./DigitalSignatureField.vue?vue&type=script&lang=js"
import style0 from "./DigitalSignatureField.vue?vue&type=style&index=0&id=59a48a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a48a98",
  null
  
)

export default component.exports